module.exports = __webpack_public_path__ + "static/img/fpdh.1da54c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fpdh.png
// module id = eBSZ
// module chunks = 0